export enum SetupChecklistItemId {
  CreateAccount = 'create-account',
  FirstGoal = 'first-goal',
  FirstTask = 'first-task',
  PlanTomorrow = 'plan-tomorrow',
  Habits = 'habits',
  ConnectCalendar = 'connect-calendar',
}

export type ComputeSetupChecklistItemsInput = {
  goalCount: number;
  habitCount: number;
  hasCompletedTaskOrHabit: boolean;
  hasAnyTask: boolean;
  hasFutureTask: boolean;
  hasCalendarConnection: boolean;
};

export type SetupChecklistItem = {
  id: SetupChecklistItemId;
  complete: boolean;
  useAlternateLabel: boolean;
};

export type SetupChecklistItems = {
  items: SetupChecklistItem[];
  allComplete: boolean;
};

export const computeSetupChecklistItems = ({
  goalCount,
  habitCount,
  hasCompletedTaskOrHabit,
  hasAnyTask,
  hasFutureTask,
  hasCalendarConnection,
}: ComputeSetupChecklistItemsInput): SetupChecklistItems => {
  const items: SetupChecklistItem[] = [
    {
      id: SetupChecklistItemId.CreateAccount,
      complete: true,
      useAlternateLabel: false,
    },
    {
      id: SetupChecklistItemId.FirstGoal,
      complete: goalCount >= 1,
      useAlternateLabel: false,
    },
    {
      id: SetupChecklistItemId.ConnectCalendar,
      complete: hasCalendarConnection,
      useAlternateLabel: false,
    },
    {
      id: SetupChecklistItemId.FirstTask,
      complete: hasCompletedTaskOrHabit,
      useAlternateLabel: hasAnyTask,
    },
    {
      id: SetupChecklistItemId.PlanTomorrow,
      complete: hasFutureTask,
      useAlternateLabel: false,
    },
    {
      id: SetupChecklistItemId.Habits,
      complete: habitCount >= 2,
      useAlternateLabel: habitCount === 1,
    },
  ];

  return { items, allComplete: items.every((item) => item.complete) };
};
